



























import {
  Vue, Component, Prop, Watch, Mixins, Emit,
} from 'vue-property-decorator'
import MainMixin from '../../mixins/MainMixin'
import EventBus from '../../event-bus'


@Component({
  components: {
  },
})
export default class CardList extends Mixins(MainMixin) {
  @Prop({ default: false }) mainToggle!:boolean

  @Prop({ default: '' }) mainTitle!:string

  @Prop({ default: 'Secondary' }) secondaryTitle!:string

  @Prop({ default: 'Show More' }) mainToggleName!:string

  @Prop({ default: false }) showSecondary!:boolean

  @Prop({ default: true }) showToggle!:boolean

  @Prop({ default: '600px' }) maxMainWidth!:string

  @Prop({ default: false }) showInitial!:boolean

  showSheet = false

  @Emit()
  back() {
    return true
  }

  created() {
    this.showSheet = this.showInitial
  }
}
